import * as Yup from 'yup';
import { REPAIR_PROGRESS_EVENTS, VALIDATION_REQUIRED } from '../../config';

export default Yup.object().shape({
  event: Yup.string()
    .oneOf(REPAIR_PROGRESS_EVENTS)
    .required(VALIDATION_REQUIRED),
  date: Yup.date().required(VALIDATION_REQUIRED)
});
